import * as React from 'react';
import { useDispatch } from 'react-redux';

import { openOfferFromHistory } from '../../../../actions/offersHistory';

export const useHandleOfferRowClick = (openFullscreenView: () => void) => {
  const dispatch = useDispatch();

  return React.useCallback(
    async (cianId?: number) => {
      openFullscreenView();
      await dispatch(openOfferFromHistory({ cianId }));
    },
    [dispatch, openFullscreenView],
  );
};
